import type { FC } from "react";
import {
  Alert,
  Button,
  Flex,
  Group,
  Loader,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { TextAreaWithDroppableFile } from "@jasper/forms";
import type { DesignReviewActions } from "./useDesignReviewActions";

type DesignRejectionModalProps = {
  review: DesignReviewActions;
};

export const DesignRejectionModal: FC<DesignRejectionModalProps> = ({
  review,
}) => {
  const { rejection, isReviewing } = review;
  const { newDeliveryDate, initialDeliveryDate, newDeliveryDateError } =
    rejection;

  return (
    <Modal
      opened={rejection.isOpened}
      onClose={rejection.close}
      title="Raison du rejet"
      centered
    >
      <Stack w="100%">
        {!newDeliveryDate && !newDeliveryDateError ? (
          <Flex h="100%" w="100%" justify="center" align="center">
            <Loader />
          </Flex>
        ) : (
          <>
            {newDeliveryDateError ||
              (newDeliveryDate &&
                initialDeliveryDate &&
                initialDeliveryDate < newDeliveryDate && (
                  <Alert color="red">
                    {newDeliveryDateError ? (
                      <Text>
                        Un rejet du design entrainera un délai de minimum 2
                        jours ouvrés.
                      </Text>
                    ) : (
                      <Text>
                        Un rejet du design entrainera un délai. La nouvelle date
                        de livraison estimée sera le{" "}
                        {newDeliveryDate?.toLocaleDateString(undefined, {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                        .
                      </Text>
                    )}
                  </Alert>
                ))}
            <TextAreaWithDroppableFile
              text={rejection.reason}
              onTextChange={rejection.setReason}
              files={rejection.files}
              onFilesChange={rejection.setFiles}
              autosize
              minRows={3}
              maxRows={4}
              error={rejection.error}
            />
            <Group justify="flex-end">
              <Button variant="outline" onClick={rejection.close}>
                Annuler
              </Button>
              <Button
                color="red"
                loading={isReviewing}
                onClick={rejection.submit}
              >
                Soumettre le rejet
              </Button>
            </Group>
          </>
        )}
      </Stack>
    </Modal>
  );
};
